export default {
      id: "i-facebook-usage",
      viewBox: "0 0 10 17",
      url: __webpack_public_path__ + "img/sprite.svg#i-facebook",
      toString: function () {
        return this.url;
      }
    }